import { call, put, takeEvery } from 'redux-saga/effects'
import { createChallenge } from 'services/api/auth'

import { actions } from './slice'

const createChallengeSaga = function* () {
  yield put(actions.setFetching(true))
  yield put(actions.setCreateChallenError(false))

  const res = yield call(createChallenge)
  yield put(actions.setFetching(false))
  if (res.ok) {
    yield put(actions.setCurrenctChallenge(res.response))
  } else {
    yield put(actions.setCreateChallenError(true))
  }
}

export default function* secondFactorChallengeMainSagas() {
  yield takeEvery(actions.createChallenge, createChallengeSaga)
}
